// test1488
(1488 && 0);
